<template>
  <div>
    <ThemeDefaultMenuBreadcrumb
      :items="breadcrumbs"
      active-color="primary"
    />
    <ThemeDefaultContainerPage
      title-tag="h1"
      :title="title"
      :description="description"
      title-underline
      :custom-padding="customPadding"
    >
      <ThemeDefaultMenuCategory
        :items="categories"
        class="tw-mt-2"
        :category-event-name="categoryEventName"
        :event-name="eventName"
        :fb-event-name="eventName"
        v-if="showCategory"
      />
      <div class="tw-mt-6">
        <slot />
      </div>
    </ThemeDefaultContainerPage>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  description?: string
  breadcrumbs?: BreadCrumb[]
  categories?: CategoryMenuItem[]
  customPadding?: string

  eventName?: string
  categoryEventName?: string
  showCategory?: boolean
}>(), {
  title: '',
  description: '',
  customPadding:'',
  breadcrumbs: () => [] as BreadCrumb[],
  categories: () => [] as CategoryMenuItem[],
  eventName: '',
  categoryEventName: '',
  showCategory: true,
})
</script>
